import React from "react";
import styled from "styled-components";
import COLORS from "../../../../assets/Colors";
import theme from "../../../../assets/theme";
import { Modal } from "@material-ui/core";
import { Formik } from "formik";
import { getErrorMessage } from "../../../../helpers/functions";
import { useSnackbar } from "notistack";
import EventService from "../../../../services/EventService";
import FormField from "../../../common/FormField/FormField";
import {
  PrimaryOutlinedCTAButton,
  PrimaryCTAButton,
} from "../../../common/Buttons";
import useLoader from "../../../../hooks/useLoader";
import { reasonForCancelValidationSchema } from "../../../../helpers/validationSchema";
import moment from "moment";

const RescheduleModal = ({ modal, setModal, getEventInfo }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "update event" });
      let payload = {};
      payload = {
        eventId: modal?.eventId,
        eventDate: moment(
          values?.eventDate ? values?.eventDate : new Date(),
        ).format("DD/MM/YYYY"),
        eventTime: moment(
          values?.eventTime ? values?.eventTime : new Date(),
        ).format("HH:mm"),
        rescheduleReason: values?.reasonForEvent,
      };
      const response = await EventService.reschedleGivenEvent(payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setModal({ state: false });
      getEventInfo(modal?.eventId);
    }
  }

  /**
   * @description cancel event inputs
   */

  const inputs = [
    {
      name: "reasonForEvent",
      label: `Reason for Rescheduled`,
      type: "textarea",
    },
  ];

  const rescheduled_inputs = [
    {
      name: "eventDate",
      label: `Event Date`,
      type: "date",
    },
    {
      name: "eventTime",
      label: `Event Time`,
      type: "time",
    },
  ];

  return (
    <Modal
      open={modal?.state}
      onClose={() => setModal({ state: false })}
      disableRestoreFocus={true}
    >
      <DrawerContainer>
        <Container>
          <HeadingContainer>
            <Heading>{`Rescheduled Event`}</Heading>
            <CloseModal
              onClick={() => setModal({ state: false })}
              src={require("../../../../assets/images/closeModal.svg")}
            />
          </HeadingContainer>
          <Description
            style={{
              margin: "10px 28px 20px",
              width: "400px",
              textAlign: "center",
            }}
          >
            {`Are you sure you want to Rescheduled this event`}
          </Description>
          <FormContainer>
            <Formik
              initialValues={{
                eventDate: modal?.eventDate || "",
                eventTime: modal?.eventTime || "",
                reasonForEvent: "",
              }}
              enableReinitialize
              validateOnBlur
              validateOnChange
              validationSchema={reasonForCancelValidationSchema}
              onSubmit={onFormSubmit}
            >
              {({
                values,
                handleChange,
                errors,
                handleSubmit,
                touched,
                setFieldValue,
                setFieldError,
                handleBlur,
              }) => (
                <StyledForm onSubmit={handleSubmit}>
                  {rescheduled_inputs.map((input, index) => (
                    <FormField
                      key={index}
                      {...{
                        input,
                        values,
                        handleChange,
                        errors,
                        handleSubmit,
                        touched,
                        setFieldValue,
                        setFieldError,
                        handleBlur,
                      }}
                    />
                  ))}
                  {inputs.map((input, index) => (
                    <FormField
                      key={index}
                      {...{
                        input,
                        values,
                        handleChange,
                        errors,
                        handleSubmit,
                        touched,
                        setFieldValue,
                        setFieldError,
                        handleBlur,
                      }}
                    />
                  ))}
                  <ButtonContainer>
                    <PrimaryOutlinedCTAButton
                      style={{ width: "45%" }}
                      onClick={(e) => {
                        e.preventDefault();
                        setModal(false);
                      }}
                    >
                      {"Cancel"}
                    </PrimaryOutlinedCTAButton>
                    <PrimaryCTAButton
                      style={{ width: "45%" }}
                      onClick={(e) => {
                        e.preventDefault();
                        handleSubmit();
                      }}
                    >
                      {"Submit"}
                    </PrimaryCTAButton>
                  </ButtonContainer>
                </StyledForm>
              )}
            </Formik>
          </FormContainer>
        </Container>
      </DrawerContainer>
    </Modal>
  );
};

export default RescheduleModal;

const Container = styled.div`
  margin: 0 15px;
  background-color: white;
  outline: none;
  border-radius: 8px;
  @media ${theme?.breakpoints?.sm_up} {
    margin: 0;
  }
`;

const DrawerContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media ${theme?.breakpoints?.sm_up} {
    max-width: 456px;
  }
`;

const HeadingContainer = styled.div`
  padding-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const CloseModal = styled.img`
  width: 14px;
  height: 14px;
  object-fit: contain;
  cursor: pointer;
  position: absolute;
  right: 34px;
  @media ${theme.breakpoints.sm_up} {
    right: 40px;
  }
`;

const Heading = styled.h3`
  margin: 0;
  padding: 0;
  font-size: 18px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontExtraBold};
`;

const FormContainer = styled.p`
  padding: 0px 15px 30px 15px;
  color: ${COLORS.COLOR_DARK};
  font-size: 14px;
  font-family: ${theme.fonts.primaryFontRegular};
  line-height: 1.71;
  min-height: 200px;
  @media ${theme?.breakpoints?.sm_up} {
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 30px;
  }
`;

const StyledForm = styled.form``;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
`;

const Description = styled.div`
  font-family: ${theme?.fonts?.primaryFontSemiBold};
`;
